import { Component, ViewChild, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { AdheridoEstadoControllerService, AdheridosPrevisionResiduos, DeclaracionEnvaseControllerService } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { Adherido } from '../../../models/adherido';
import { AttachedService } from '../../../services/attached.service';

@Component({
  selector: 'lib-upload-waste-forecast',
  templateUrl: './upload-waste-forecast.component.html',
  styleUrls: ['./upload-waste-forecast.component.scss']
})
export class UploadWasteForecastComponent {

  previsionResiduos!: AdheridosPrevisionResiduos;
  titulo = "Importar previsión de residuos";
  nombreArchivo: string = '';
  file: File | undefined;
  @ViewChild('fileInput') fileInput: any;
  adheridoInfo!: Adherido;
  anio!:number;
  constructor(
    public dialogRef: MatDialogRef<UploadWasteForecastComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private FormBuilder: FormBuilder,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService,
    public declaracionEnvaseService: DeclaracionEnvaseControllerService,
     public adheridoEstadoService: AdheridoEstadoControllerService,
    private downloadService: DownloadService,
    private attachedSrv: AttachedService,
  ) {
    this.previsionResiduos = this.data.previsionResiduos;
    this.adheridoInfo = this.data.adheridoInfo;
    this.anio = this.data.anio;
  }

  ngOnInit() {
  }


  adjuntar() {
    this.fileInput.nativeElement.click();
  }

  handleFileInput(event: any) {
    this.file = event.target.files[0];
    if (this.file && this.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.nombreArchivo = this.file.name;
      this.snackBarSrv.showSnackBar('Se ha adjuntado el archivo Excel correctamente.', 'success');
    } else {
      this.snackBarSrv.showSnackBar('Por favor, seleccione un archivo Excel (.xlsx).', 'error');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  Importar() {
    if(this.file) {
      this.spinnerSrv.loadingShow();
       this.adheridoEstadoService.importPrevisionResiduosSddrCerrado(this.adheridoInfo.id!, this.anio, this.file ).subscribe({
         next: res => {
           this.spinnerSrv.loadingHide();
           this.snackBarSrv.showSnackBar('Importación realizada correctamente', 'success');
           this.dialogRef.close(true);
         },
         error: error => {
           this.spinnerSrv.loadingHide();
           // Si hay errores de validación (puede haber más de uno), los mostramos
           if (error.error?.validationErrors && Array.isArray(error.error.validationErrors) && error.error.validationErrors.length > 0) {
              if (error.error.validationErrors.length === 1) {
                const single = error.error.validationErrors[0];
                const msg = single?.defaultMessage ? `${single.defaultMessage}\n\n` : `${JSON.stringify(single)}\n\n`;
                this.snackBarSrv.showSnackBar(msg, 'error');
             } else {
                const messages = error.error.validationErrors
                  .map((ve: any, idx: number) => ve?.defaultMessage ? `${ve.defaultMessage}\n\n` : `${JSON.stringify(ve)}\n\n`)
                  .join('');
                this.snackBarSrv.showSnackBar(messages, 'error');
             }

           } else if (error.error?.detail) {
             this.snackBarSrv.showSnackBar(error.error?.detail, 'error');
           } else {
             this.snackBarSrv.showSnackBar('Ha ocurrido un error al importar la plantilla. Por favor, contacte con el administrador de sistemas', 'error');
           }
         }
       })
    }
  }

  descargar() {
    this.spinnerSrv.loadingShow();
     this.adheridoEstadoService.exportPrevisionResiduosSddrCerradoTemplate('response').subscribe({
       next: res => {
         console.log(res.headers);
         const templateName = this.downloadService.getFileName(res.headers);
         this.downloadService.downloadBlob(res.body!, templateName!);
         this.spinnerSrv.loadingHide();
       },
       error: error => {
         this.spinnerSrv.loadingHide();
         this.snackBarSrv.showSnackBar('Ha ocurrido un error al descargar la plantilla', 'error');
       }
     })
  }


}

